// Module
var code = "<react-component name=\"ViewInterruptionRequest\"></react-component>\n";
// Exports
module.exports = code;